import { render, staticRenderFns } from "./PrepareSelfie.vue?vue&type=template&id=958f7ebc&scoped=true&"
import script from "./PrepareSelfie.vue?vue&type=script&lang=ts&"
export * from "./PrepareSelfie.vue?vue&type=script&lang=ts&"
import style0 from "./PrepareSelfie.vue?vue&type=style&index=0&id=958f7ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958f7ebc",
  null
  
)

export default component.exports